module.exports = new Promise(resolve => {
    const script = document.createElement('script');
    const meta = document.querySelector('meta[name="widen:env"]');
    const env = meta?.content ?? window.env;

    script.src = env === 'stage' ? 'https://static.widencdn-stage.net/einstein@4/remoteEntry.js' : 'https://static.widencdn.net/einstein@4/remoteEntry.js';
    script.onload = () => {
      resolve({
        get: window.einstein.get,
        init: window.einstein.init
      })
    };
    script.fetchPriority = 'high';
    script.defer = true;

    document.head.appendChild(script);
  });